export const DEFAULT_CHAT_MESSAGE_GROUPING_DURATION = 60000 * 60 * 6; // 6 hours in milliseconds

export const TEMP_PARTICIPANT_ID = 'temporary-participant-id';
export const TEMP_AI_ASSISTANT_PARTICIPANT_ID = 'temporary-assistant-participant-id';
export const TEMP_CONVERSATION_ID = 'temporary-conversation-id';
